export * from './src/wixpress-cookie-banner-settings-v1-cookie-banner-settings-cookie-banner-settings.context.js';
